import { Autocomplete, CircularProgress, TextField } from "@mui/material"
import { useGetProductsQuery } from "@store/services/productsService"
import { useImmerAtom } from "jotai-immer"
import { memo } from "react"
import { AutocompleteOnChange, OrgToDivToProds } from "@components/NodeLink/types"
import { linkAtom } from "@components/NodeLink/linkAtom"

const DivAutocomplete = memo((props: { orgToDivToProds: OrgToDivToProds }) => {
  const [link, updateLink] = useImmerAtom(linkAtom)
  const { isFetching } = useGetProductsQuery({ roleHint: "whatif" })
  const skip = !link.org

  const handleChange: AutocompleteOnChange = (_event, newValue) => {
    updateLink((draft) => {
      draft.div = newValue ?? ""
      draft.prod = ""
      draft.family = ""
      draft.version = ""
      draft.node = ""
    })
  }

  const divisions = [...(props.orgToDivToProds.get(link.org)?.keys() ?? [])]
  const sortedOptions = divisions.toSorted((divA, divB) => divA.localeCompare(divB))

  return (
    <Autocomplete
      options={sortedOptions}
      value={link.div || null}
      onChange={handleChange}
      renderInput={(params) => <TextField {...params} label="Division" />}
      disabled={skip}
      isOptionEqualToValue={(option, value) => option === value}
      loading={isFetching}
      loadingText={<CircularProgress size={20} />}
    />
  )
})
DivAutocomplete.displayName = "DivAutocomplete"

export default DivAutocomplete
